<div class="order-by" (click)="onOrderByClick()">
  <ng-content></ng-content>
  <i [ngClass]="order === SortDirection.ASC ? 'icon-sort-descending' : 'icon-sort-ascending'"></i>
</div>
